import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilState } from 'recoil';
import { InputNumber } from '../../../components/inputs/InputNumber';
import TitleSection from '../../../components/layout/TitleSection';
import { dashboardItemsCountState } from '../../../dashboard/store/dashboard.state';

const SettingsDashboardSetup: React.FC = () => {
  const { t } = useTranslation('settings');
  const [itemsCount, setItemsCount] = useRecoilState(dashboardItemsCountState);

  return (
    <TitleSection
      inPanelView
      title={t`Dashboard Settings`}
      classNameInner="p-4"
    >
      <p className="my-4 text-sm">
        {t`Configure how the dashboard displays content`}
      </p>
      <InputNumber
        title={t`Items per page`}
        value={itemsCount}
        range={[5, 100]}
        onChange={setItemsCount}
      />
      <p className="my-4 text-sm">
        {t`Number of items to display per page in dashboard views (min: 5, max: 100)`}
      </p>
    </TitleSection>
  );
};

export default SettingsDashboardSetup;
